import React from 'react';
import { OverlayComponent } from 'app/components';
import { hasTranslationsValid } from 'app/components/translation/has-translations-valid';
import { validateDefaultFilters } from 'app/area/shared/default-filters/utils/validate-default-filters';
import { validateCompanyReport } from '../utils/validate-company-report';
import { validateSavedReports } from '../utils/validate-saved-report';
import { CompanyReportContainerProps } from '../types';
import { CompanyReportStickyHeader } from './company-report-sticky-header';

export const CompanyReportContainer: React.FC<CompanyReportContainerProps> = ({
  formState, mainLanguage, shouldPrompt, translation, companyReportAccess, children,
  switchTranslationsToggle, saveCompanyReport, deleteCompanyReport,
  updateValidation, updateSavedReportValidation, updateFiltersValidation, displayError
}) => {

  const { companyReportItem, savedReports, filters, fetching, fetchingTemplate,
    saving, deleting, languageOptions, validation } = formState;

  const onSave = () => {
    const formValidation = validateCompanyReport(companyReportItem, languageOptions, translation);
    const savedReportValidation = validateSavedReports(savedReports, translation);
    const defaultFiltersValidation = validateDefaultFilters(filters, translation);

    updateValidation({ ...validation, ...formValidation });
    updateSavedReportValidation(savedReportValidation);
    updateFiltersValidation(defaultFiltersValidation);

    if (Object.keys(formValidation).length > 0 ||
      Object.keys(savedReportValidation).length > 0 ||
      Object.keys(defaultFiltersValidation).length > 0) {

      !hasTranslationsValid(formValidation.language, mainLanguage) && switchTranslationsToggle(true);
      displayError(translation.company_report_validation_error);
      return;
    }

    saveCompanyReport(companyReportItem);
  };

  const companyReportName = companyReportItem.language
    ?.find(languageItem => languageItem.value === mainLanguage)
    ?.description;

  return <>
    <OverlayComponent
      displayOverlay={saving || deleting}
      overlayText={saving
        ? translation.saving_company_report
        : translation.deleting_company_report} />
    <CompanyReportStickyHeader
      companyReportItem={companyReportItem}
      companyReportAccess={companyReportAccess}
      name={companyReportName}
      shouldPrompt={shouldPrompt}
      fetching={fetching}
      fetchingTemplate={fetchingTemplate}
      displayError={displayError}
      onSave={onSave}
      onDelete={deleteCompanyReport}
      translation={translation} />
    {children}
  </>;
};
